import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
import { BaseUrl } from "../../helper/BaseUrl";

const careerListEndpoint = ApiEndpoints.career.careerList;

const tableHeader = ["date", "Name", "email", "phone", "address", "message", "resume",];
const tbody = ["createdAt", "name", "email", "phone", "address", "message", "resume"];

export default function Career() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
        const response = await ApiRequest("GET", careerListEndpoint);
        const result = response.career.map((item) => ({
            ...item,
            resume: item.resume ? (
            <a href={`${BaseUrl}/${item.resume}`} download rel="noopener noreferrer"><img src="/assets/download.webp" target="_blank" style={{width: "16px"}} alt="download"/></a>
            ) : (
            "No file"
            ),
        }));
        setData(result);
        } catch (error) {
        console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'career',
      user: 'Admin',
      innerpage: 'career'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        showAction={false}
        />
    </div>
    </>
  )
}
